/* src/app/feature-modules/forms/create-edit-forms/create-edit-forms.component.css */
.sub-entry {
  width: 50%;
  float: left;
}
.icons-list {
  display: inline-block;
  vertical-align: top;
  padding: 24px;
}
.img {
  height: 65px;
  padding: 5px;
  cursor: pointer;
}
.active-icon {
  background-color: rgba(0, 178, 226, 0.18);
  border: solid 2px #00b2e2;
}
.info {
  background-color: #2196F3;
}
.icons-wrapper {
  height: 100%;
  width: 80%;
  padding: 0px;
}
.container {
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;
  display: flex;
}
.container .btn-holder {
  justify-content: flex-end;
  display: flex;
}
.img-wrapper {
  padding: 15px;
  display: inline-block;
}
img {
  height: 65px;
  padding: 5px;
  cursor: pointer;
}
img:hover {
  background-color: rgba(0, 178, 226, 0.18);
  border: solid 2px #00b2e2;
}
/*# sourceMappingURL=create-edit-forms.component.css.map */
